export default "__VITE_ASSET__BY50hVQo__"